import React, { useEffect, useMemo, useRef, useState } from "react";

import {
  stringToDateObject,
  dateToString,
} from "../../utils/Formater/DateFormat";

import AddNewGreenIcon from "../../icons/dashboard/AddNewGreen";
import CloseDanger from "../../icons/dashboard/CloseDangerIcon";
import { CloseIcon } from "../../icons/close/CloseIcon";
import DeleteIcon from "../../icons/dashboard/DeleteIcon";
import Skeleton from "react-loading-skeleton";
import {
  findObjectByValue,
  formatCurrency,
  formatMinAndMaxAmount,
  generateArrayUpToValue,
  getPerOptions,
  rowHelperText,
} from "utils/HelperFunctions";
import CustomCalender from "components/calender/CustomCalender";
import CustomTooltip from "components/ui-component/CustomTooltip";
import InputField from "./InputField";
import Button from "components/form/Button";
import { useUserData } from "store/slices/authSlice";
import InputSelect from "components/ui-component/InputSelect";
import { AddCircleIconBlue } from "utils/icon";
import CustomAmountInput from "./CustomAmountInput";
import useOutsideClick from "hooks/useOutsideClick";
import moment from "moment";
import MinimizeIcon from "icons/dashboard/MinimizeIcon";
import ExpandIcon from "icons/dashboard/ExpandIcon";
import { useAppSelector } from "store/hooks";
import { RootState } from "store/store";
import {
  getTransactionConvenienceFee,
  getTransactionScheduleDate,
} from "utils/updatePaymentPlanUtils";

interface CustomeTable1Props {
  isdisplayFeeColumn?: boolean;
  isSmContent?: any;
  dataArr?: any;
  setDataArr?: any;
  amountType?: any;
  isExpanded?: any;
  setIsExpanded?: any;
  isCustom?: boolean;
  isDateCustom?: boolean;
  totalAmount?: any;
  addNewRow?: any;
  removeRow?: any;
  handleChange?: any;
  grandTotal?: any;
  isSettlementEnable?: any;
  isLoading?: any;
  handleSave: any;
  makePayment?: boolean;
  data?: any;
  isUpdatePlan?: boolean;
  amtErr?: string | null;
  getStartLimit?: any;
  addLimit?: any;
  isStartDateError?: boolean;
  setIsStartDateError?: (value: boolean) => void;
  startDateErr?: boolean;
  dateErrMsg?: string | null;
  setDateErrMsg?: (val: string | null) => void;
  isEndDateError?: boolean;
  setIsPaymentProcessing?: (val: boolean) => void;
  amountLimitBalance?: number;
}
let storeBalance = 0;
let remain = 0;

const formatScheduleDate = (transaction: any) => {
  const dateValue = getTransactionScheduleDate(transaction);
  return dateValue ? dateToString(dateValue) : "";
};

const CustomTable1 = ({
  isdisplayFeeColumn = true,
  dataArr,
  amountType,
  isExpanded,
  setIsExpanded,
  isCustom = false,
  isDateCustom = false,
  totalAmount,
  addNewRow,
  removeRow,
  handleChange,
  grandTotal,
  isLoading,
  handleSave,
  data,
  makePayment = false,
  amtErr = null,
  getStartLimit = () => {},
  addLimit,
  isStartDateError = false,
  setIsStartDateError = () => {},
  startDateErr = false,
  dateErrMsg = null,
  setDateErrMsg = () => {},
  isEndDateError = false,
  setIsPaymentProcessing = () => {},
  amountLimitBalance,
}: CustomeTable1Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [rowIndex, setRowIndex] = useState<any>(undefined);
  const [isError, setIsError] = useState<boolean>(false);
  const [options, setOptions] = useState(getPerOptions());
  const [newData, setNewData] = useState([]);
  const [totalPercentage, setTotalPercentage] = useState(0);

  const [isMobileOpen, setIsMobileOpen] = useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);
  const [isPercentHintDismissed, setIsPercentHintDismissed] =
    useState<boolean>(false);
  const [touchedArray, setTouchedArray] = useState(
    Array(newData.length).fill(false)
  );
  const [touchedArrayPhone, setTouchedArrayPhone] = useState(
    Array(newData.length).fill(false)
  );

  const { generalSettings } = useAppSelector((state) => state.payment);
  const userData = useUserData();
  const customcalenderRef = useRef(null);

  const { min, max } = formatMinAndMaxAmount(
    generalSettings,
    amountLimitBalance ?? userData?.data?.accountData?.balance
  );

  const checkCalcAmt = () => {
    let val = 0;
    newData?.map((x: any) => (val += x?.amount));
    setTotalPercentage(val);
  };

  const handleBlur = (index: any, value: any) => {
    const numericValue = value ? parseFloat(value.replace(/,/g, "")) : 0;
    if (isCustom) {
      if (amountType === "amount") {
        if (numericValue < min || numericValue > max) {
          setIsError(true);
          let d: any = newData?.map((x: any, idx) => {
            return {
              ...x,
              isNValid: idx === index ? true : x?.isNValid,
            };
          });
          setNewData(d || []);
        } else {
          setIsError(false);
          let d: any = newData?.map((x: any, idx) => {
            return {
              ...x,
              isNValid: idx === index ? false : x?.isNValid,
            };
          });
          setNewData(d || []);
        }
      } else if (amountType === "percent") {
        if (numericValue < 1 || numericValue > 100) {
          setIsError(true);
          let d: any = newData?.map((x: any, idx) => {
            return {
              ...x,
              isNValid: idx === index ? true : x?.isNValid,
            };
          });
          setNewData(d || []);
        } else {
          setIsError(false);
          let d: any = newData?.map((x: any, idx) => {
            return {
              ...x,
              isNValid: idx === index ? false : x?.isNValid,
            };
          });
          setNewData(d || []);
        }
        let val = 0;
        newData?.map((x: any) => (val += x?.amount));
        setTotalPercentage(val);
        if (val > 100) {
          let d: any = newData?.map((x: any, idx) => {
            return {
              ...x,
              isNValid: idx === index ? true : x?.isNValid,
            };
          });
          setNewData(d || []);
        }
      }
    }
  };

  useEffect(() => {
    let d = dataArr?.map((x: any) => {
      let amt = x?.amount ? parseFloat(x?.amount) : 0;
      return {
        ...x,
        isNValid: amt === 0 ? true : false,
        amount: x?.amount ? amt : 0,
        selectedPr:
          amountType === "percent"
            ? amt > 0
              ? generateArrayUpToValue(dataArr, amt)
              : []
            : [],
      };
    });
    setNewData(d || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataArr]);

  useEffect(() => {
    const dOptions = [];
    for (let i = 1; i <= 100 - totalPercentage; i++) {
      dOptions.push({ name: `${i}%`, value: i });
    }
    setOptions(dOptions);
    setIsPercentHintDismissed(false);
  }, [totalPercentage]);

  const remainingPercentage = 100 - totalPercentage;
  const showPercentHint =
    isCustom &&
    amountType === "percent" &&
    !isLoading &&
    isButtonDisabled &&
    totalPercentage > 0 &&
    !isPercentHintDismissed;
  const percentHintMessage =
    remainingPercentage > 0
      ? `Select a percentage for every payment — ${remainingPercentage}% is still unassigned.`
      : `100% is assigned but some payments are at 0%. Lower another payment's percentage.`;

  useEffect(() => {
    if (amountType === "percent") {
      checkCalcAmt();
    }
  }, [newData, amountType]);

  const total_fee = useMemo(() => {
    const total = dataArr?.reduce((sum: number, curr: any) => {
      return sum + getTransactionConvenienceFee(curr);
    }, 0);

    return total;
  }, [dataArr]);

  useEffect(() => {
    const checkAmounts = () => {
      if (data && data.paymentPlan) {
        if (data?.paymentPlan?.schedule_amount === "custom") {
          const transactions = data.paymentPlan.transactions || [];
          if (transactions.length > 0) {
            if (amountType === "percent") {
              if (
                transactions.some(
                  (items: any) =>
                    isNaN(items.amount) ||
                    parseInt(items.amount) === 0 ||
                    !items.amount
                )
              ) {
                return true;
              } else {
                return false;
              }
            } else {
              if (
                transactions.some(
                  (items: any) =>
                    isNaN(items.amount) ||
                    parseInt(items.amount) === 0 ||
                    !items.amount ||
                    Number(items.amount) < min ||
                    Number(items.amount) > max
                )
              ) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return true;
          }
        }
        const transactions = data.paymentPlan.transactions || [];
        const hasZeroAmount = transactions.some(
          (transaction: any) => transaction.amount === 0
        );
        const grandTotal = data.paymentPlan.grand_total;
        return hasZeroAmount || !Number(grandTotal);
      }
      return true;
    };
    setIsButtonDisabled(checkAmounts());
  }, [data, amountType, min, max]);

  return (
    <>
      <div
        className={`${
          isExpanded &&
          "fixed top-[130px] w-[762px] min-h-[calc(var(--shell-vh)-210px)] bg-white border-2"
        } lg:flex flex-col h-[100%] hidden`}
      >
        <div
          className={`${isExpanded && "fixed top-[130px] w-[762px] h-auto bg-white"} flex flex-col h-auto`}
        >
          {/* HEADER */}
          <div className="flex bg-white px-[20px] py-[10px] gap-x-[20px] border-b-[1px] border-b-gray">
            <div
              className={`${
                isdisplayFeeColumn ? "w-[5%]" : "w-[10%]"
              } text-sm leading-[18px] font-normal text-txtParagraph`}
            >
              #
            </div>
            <div
              className={`${
                isdisplayFeeColumn ? "w-[28%]" : "w-[40%]"
              } text-sm leading-[18px] capitalize font-normal text-txtParagraph`}
            >
              Payment date
            </div>
            {isdisplayFeeColumn && (
              <div className="w-[15%] text-sm capitalize leading-[18px] font-normal text-txtParagraph">
                Fee
              </div>
            )}
            <div className="w-[26%] text-sm capitalize leading-[18px] font-normal text-txtParagraph">
              {amountType}
            </div>
            <div className="w-[20%] text-sm capitalize leading-[18px] font-normal text-txtParagraph">
              Balance
            </div>
            <div className="w-[8%] text-sm uppercase leading-[18px] font-normal text-txtParagraph">
              <span
                className="cursor-pointer"
                onClick={() => {
                  setIsExpanded(!isExpanded);
                }}
              >
                {isExpanded ? <MinimizeIcon /> : <ExpandIcon />}
              </span>
            </div>
          </div>

          {/* CONTENT */}
          {isLoading ? (
            <div className="flex items-center px-[20px] py-[5px] gap-x-[20px]">
              <div className={`${isdisplayFeeColumn ? "w-[4%]" : "w-[7%]"} `}>
                <Skeleton count={10} className="w-full h-[34px] mb-[7px]" />
              </div>
              <div
                className={`${isdisplayFeeColumn ? "w-[25%] " : "w-[35%]"} `}
              >
                <Skeleton count={10} className="w-full h-[34px] mb-[7px]" />
              </div>
              {isdisplayFeeColumn && (
                <div className="w-[15%]">
                  <Skeleton count={10} className="w-full h-[34px] mb-[7px]" />
                </div>
              )}
              <div
                className={`${isdisplayFeeColumn ? "mr-[20px]" : "w-[22%]"} `}
              >
                <Skeleton count={10} className="w-full h-[34px] mb-[7px]" />
              </div>
              <div className="w-[20%]">
                <Skeleton count={10} className="w-full h-[34px] mb-[7px]" />
              </div>
            </div>
          ) : (
            <div>
              {newData?.map((data: any, index: number) => {
                const tempDataArr = dataArr?.map((item: any) =>
                  getTransactionScheduleDate(item)
                );
                const payment_date = formatScheduleDate(data);
                if (index === 0) {
                  storeBalance = userData?.data?.accountData?.balance;
                } else {
                  storeBalance = remain;
                }
                remain = storeBalance - data?.amount;

                const isProcessedRow =
                  Boolean(data?.status) && data?.status !== "Pending";
                return (
                  <div
                    className="flex items-center px-[20px] py-[5px] gap-x-[20px] animate__animated animate__fadeIn animate__faster"
                    key={`${data?.date || data?.payment_date || ""}-${index}`}
                    // A filled animation keeps the row in its own stacking
                    // context, which paints later rows over this row's open
                    // dropdown — so drop the classes once the fade is done.
                    onAnimationEnd={(e) =>
                      e.currentTarget.classList.remove(
                        "animate__animated",
                        "animate__fadeIn",
                        "animate__faster"
                      )
                    }
                  >
                    <div
                      className={`${
                        isdisplayFeeColumn ? "w-[5%]" : "w-[10%]"
                      }  font-normal text-base uppercase leading-[19px] text-txtParagraph`}
                    >
                      {index + 1}
                      <span className="text-xs lowercase">
                        {rowHelperText(index + 1)}
                      </span>
                    </div>
                    <div
                      className={` ${
                        isdisplayFeeColumn ? "w-[28%] " : "w-[40%]"
                      }  text-xs uppercase leading-[16px] text-txtPrimary`}
                    >
                      {/* CALENDER */}
                      {/* w-full (capped) instead of the old fixed 190px: a fixed
                          inner width put a min-content floor under this cell, so
                          flex shrank the body row differently from the header row
                          and every column to the right drifted out of alignment. */}
                      <div
                        ref={customcalenderRef}
                        className={`relative w-full max-w-[190px]`}
                      >
                        <div
                          className={`relative`}
                          onClick={() => {
                            if (!makePayment) {
                              if (isDateCustom && data?.status === "Pending") {
                                setRowIndex(index + 1);
                                setIsOpen(!isOpen);
                              }
                            } else {
                              if (isDateCustom) {
                                setRowIndex(index + 1);
                                setIsOpen(!isOpen);
                              }
                            }
                          }}
                        >
<CustomTooltip
                          disabled={!isProcessedRow}
                          place="top"
                          maxWidth="240px"
                          className="block w-full text-left"
                          content={`<div class="text-xs leading-[18px] font-normal normal-case max-w-[210px]">This payment has already been processed and can't be edited.</div>`}
                        >
                                                  <div
                            className={`${
                              data?.status !== "Pending" || !isDateCustom
                                ? "cursor-not-allowed pointer-events-none"
                                : "cursor-pointer"
                            } w-full`}
                          >
                            <InputField
                              type="dc-calendar"
                              disabled={
                                data?.status !== "Pending" || !isDateCustom
                              }
                              noLabel
                              _className="cursor-pointer hover:!border-strokeActive"
                              placeholder="MM/DD/YYYY"
                              value={payment_date}
                            />
                          </div>
                        </CustomTooltip>
                        </div>
                        {isDateCustom && isOpen && index + 1 === rowIndex && (
                          <CustomCalender
                            value={
                              payment_date
                                ? payment_date &&
                                  stringToDateObject(payment_date)
                                : data.date && stringToDateObject(data.date)
                            }
                            minDate={new Date()}
                            maxDate={getStartLimit()}
                            disableTiles={tempDataArr.filter(
                              (itm: any) => itm !== payment_date
                            )}
                            openCalendar={isOpen}
                            setOpenCalendar={setIsOpen}
                            onChange={(date: any) => {
                              setIsOpen(false);
                              setIsPaymentProcessing(true);

                              handleChange(
                                "date",
                                index,
                                dateToString(date),
                                data
                              );
                            }}
                          />
                        )}
                      </div>
                    </div>
                    {isdisplayFeeColumn && (
                      <div className="w-[15%] text-sm uppercase leading-[18px] text-gray1">
                        {formatCurrency(getTransactionConvenienceFee(data)) ||
                          "$0.00"}
                      </div>
                    )}
                    <div className="w-[26%] text-sm uppercase leading-[18px]  text-txtPrimary">
                      {/* amount column   */}

                      <div className="w-[120px]">
                        <CustomTooltip
                          disabled={!isProcessedRow}
                          place="top"
                          maxWidth="240px"
                          className="block w-full text-left"
                          content={`<div class="text-xs leading-[18px] font-normal normal-case max-w-[210px]">This payment has already been processed and can't be edited.</div>`}
                        >
                        {amountType === "percent" ? (
                          <>
                            <InputSelect
                              maxHight="!max-h-[160px]"
                              // The list is clipped by the table's scroll area,
                              // so the bottom rows open their list upward.
                              isUpDropDown={
                                newData.length > 3 &&
                                index >= newData.length - 2
                              }
                              selected={findObjectByValue(
                                getPerOptions(),
                                data?.amount || 0
                              )}
                              value={
                                data?.amount !== undefined &&
                                data?.amount !== null &&
                                data?.amount !== ""
                                  ? `${data.amount}%`
                                  : ""
                              }
                              // error={
                              //   touchedArrayPer[index] &&
                              //   (!data?.amount || data?.amount === 0)
                              // }
                              options={
                                data?.selectedPr?.length
                                  ? data?.selectedPr
                                  : options
                              }
                              setSelected={(val: any) => {
                                const percentage = Number(val?.value);
                                if (
                                  !Number.isFinite(percentage) ||
                                  percentage <= 0
                                ) {
                                  return;
                                }
                                setIsPaymentProcessing(true);
                                handleChange(
                                  "percent",
                                  index,
                                  percentage,
                                  data
                                );
                              }}
                              noLabel
                              disabled={data?.status !== "Pending"}
                            />
                          </>
                        ) : (
                          <>
                            <CustomAmountInput
                              isError={
                                touchedArray[index] &&
                                (data.amount < min || data.amount > max)
                              }
                              isDollar={amountType === "amount"}
                              isPercentage={amountType === "percent"}
                              inputValue={
                                data.amount ? data?.amount?.toString() : ""
                              }
                              setinputValue={(val: any) => {}}
                              disabled={
                                isCustom && data?.status === "Pending"
                                  ? false
                                  : true
                              }
                              onBlur={(e: any) => {
                                setIsPaymentProcessing(true);
                                const val = e.target.value;
                                let amt = val ? val?.replace(/,/g, "") : "0.00";
                                setTouchedArray((prev) => {
                                  const updatedTouchedArray = [...prev];
                                  updatedTouchedArray[index] = true;
                                  return updatedTouchedArray;
                                });
                                handleChange(
                                  amountType === "percent"
                                    ? "percent"
                                    : "amount",
                                  index,
                                  Number(amt)
                                );
                                handleBlur(index, e.target.value);
                              }}
                              checkAmt={false}
                              className={`!pl-[23px]`}
                              showErr={false}
                            />
                          </>
                        )}
                        </CustomTooltip>
                      </div>
                    </div>
                    <div className="w-[20%] text-[13px] uppercase leading-[17px] text-darkGray text-left">
                      <span className="text-lg leading-[24px] font-medium text-txtPrimary mr-[3px]">
                        {formatCurrency(
                          amountType === "percent" || makePayment
                            ? data?.balance
                            : remain
                        ) || "$0.00"}
                      </span>
                    </div>
                    {/* IF CUSTOM ONLY SHOW */}
                    <div className="w-[8%] text-sm flex items-end gap-x-[5px] uppercase leading-[18px] font-bold text-blue">
                      {isDateCustom && (
                        <>
                          {dataArr.length > 1 && data?.status === "Pending" && (
                            <span
                              className="cursor-pointer w-[18px] h-[18px]"
                              onClick={() => {
                                removeRow(index);
                              }}
                            >
                              <DeleteIcon />
                            </span>
                          )}
                          {index === dataArr.length - 1 && (
                            <span
                              className="cursor-pointer w-[18px] h-[18px]"
                              onClick={() => {
                                addNewRow(index);
                              }}
                            >
                              <AddNewGreenIcon />
                            </span>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {/* SUBTOTAL */}
          <div className="animate__animated animate__fadeIn flex bg-white px-[20px] py-[18px] gap-x-[20px] border-y-[1px] border-y-gray">
            <div
              className={`${
                isdisplayFeeColumn ? "w-[5%]" : "w-[10%]"
              } text-sm uppercase leading-[18px]`}
            ></div>
            <div
              className={`${
                isdisplayFeeColumn ? "w-[28%]" : "w-[40%]"
              } text-sm uppercase leading-[18px] text-txtPrimary font-medium`}
            >
              Subtotal
            </div>
            {isdisplayFeeColumn && (
              <div className="w-[15%] text-lg uppercase leading-[18px] text-txtPrimary">
                {isLoading ? (
                  <Skeleton className="h-[24px] w-full" />
                ) : (
                  <>{total_fee && (formatCurrency(total_fee) || "0.00")}</>
                )}
              </div>
            )}
            <div className="w-[26%] text-lg uppercase leading-[18px] font-medium text-txtPrimary">
              {isLoading ? (
                <Skeleton width={80} height={24} />
              ) : (
                <>
                  {" "}
                  {totalAmount && totalAmount !== "0.00"
                    ? formatCurrency(totalAmount) || "0.00"
                    : "$0.00"}
                </>
              )}
            </div>
            <div className="w-[20%]"></div>
            <div className="w-[8%]"></div>
          </div>

          {/* TOTAL */}
          <div className="animate__animated animate__fadeIn flex bg-white px-[20px] pt-[13px] pb-[9px] gap-x-[20px] items-center">
            <div
              className={`${
                isdisplayFeeColumn ? "w-[5%]" : "w-[10%]"
              } text-sm uppercase leading-[18px]`}
            ></div>
            <div
              className={`${
                isdisplayFeeColumn ? "w-[28%]" : "w-[40%]"
              } text-sm uppercase leading-[18px] text-txtPrimary font-medium`}
            >
              Total
            </div>
            {isdisplayFeeColumn && (
              <div className="w-[15%] text-sm uppercase leading-[18px] text-txtPrimary"></div>
            )}
            {isLoading ? (
              <Skeleton width={100} height={30} />
            ) : (
              <div className="w-[26%] text-2xl uppercase leading-[31px] font-medium text-txtPrimary">
                {grandTotal && grandTotal !== "0.00"
                  ? formatCurrency(grandTotal) || "0.00"
                  : "$0.00"}
              </div>
            )}
            <div className="w-[20%] text-sm uppercase leading-[18px]"></div>
            <div className="w-[8%] text-sm uppercase leading-[18px]"></div>
          </div>

          {isLoading ? (
            <></>
          ) : (
            <>
              {isCustom && amtErr && (
                <p className="mt-2 text-xs text-red" role="alert">
                  {amtErr}
                </p>
              )}
              <div className="flex justify-end mt-2">
                <div className="mt-4 w-[140px]">
                  <Button
                    text="Next"
                    className="w-full"
                    isDisabled={
                      isLoading ||
                      isButtonDisabled ||
                      isEndDateError ||
                      (amtErr ? true : false)
                    }
                    onClick={() => {
                      handleSave();
                    }}
                  />
                </div>
              </div>
            </>
          )}

          {/* IF Error */}
          {isCustom && isError && amountType === "amount" && (
            <div className="absolute bottom-[72px] left-0 right-0 mx-auto w-fit max-w-full px-5">
              <div className="w-full flex px-[20px] py-[14px] shadow-[0px_5px_15px_rgba(223,238,255,0.2)] rounded-t-[7px] bg-lightRed">
                <div className="text-red text-base leading-[21px]">
                  Amount should be between {formatCurrency(min)} to{" "}
                  {formatCurrency(max)}
                </div>
                <div className="flex items-center ml-[5px]">
                  <span
                    onClick={() => {
                      setIsError(false);
                    }}
                    className="GreenIcon cursor-pointer w-[22px] h-[21px]"
                  >
                    <CloseDanger />
                  </span>
                </div>
              </div>
            </div>
          )}

          {isStartDateError && (
            <div className="absolute bottom-[72px] left-0 right-0 mx-auto w-fit max-w-full px-5">
              <div className="w-full flex px-5 py-[14px] shadow-[0px_5px_15px_rgba(223,238,255,0.2)] rounded-t-[7px] bg-lightRed">
                <div className="text-red text-base leading-[21px]">
                  The first transaction’s date exceeds the allowed start date
                  limit of {moment(getStartLimit()).format("MM/DD/YYYY")}.
                </div>
                <div className="flex items-center ml-[5px]">
                  <span
                    onClick={() => {
                      setIsStartDateError(false);
                    }}
                    className="GreenIcon cursor-pointer w-[22px] h-[21px]"
                  >
                    <CloseDanger />
                  </span>
                </div>
              </div>
            </div>
          )}

          {isEndDateError && dateErrMsg && (
            <div className="absolute bottom-[72px] left-0 right-0 mx-auto w-fit max-w-full px-5">
              <div className="w-full flex px-5 py-[14px] shadow-[0px_5px_15px_rgba(223,238,255,0.2)] rounded-t-[7px] bg-lightRed">
                <div className="text-red text-base leading-[21px]">
                  {dateErrMsg}.
                </div>
                <div className="flex items-center ml-[5px]">
                  <span
                    onClick={() => {
                      setDateErrMsg(null);
                    }}
                    className="GreenIcon cursor-pointer w-[22px] h-[21px]"
                  >
                    <CloseDanger />
                  </span>
                </div>
              </div>
            </div>
          )}

          {showPercentHint && (
            <div className="absolute bottom-[72px] left-0 right-0 mx-auto w-fit max-w-[520px] px-5">
              {/* Informational, not an error: the customer simply hasn't
                  finished assigning percentages, so this reuses the warning-
                  bar yellow instead of the error red. */}
              <div className="w-full flex px-5 py-[14px] shadow-[0px_5px_15px_rgba(223,238,255,0.2)] rounded-t-[7px] bg-lightYellow border border-btnYellowDisable">
                <div className="text-yellow font-medium text-base leading-[21px]">
                  {percentHintMessage}
                </div>
                <div className="flex items-center ml-[5px]">
                  <span
                    onClick={() => {
                      setIsPercentHintDismissed(true);
                    }}
                    className="cursor-pointer"
                  >
                    <CloseIcon size={20} />
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="w-full flex flex-col lg:hidden">
        {isLoading ? (
          <>
            {[1, 2, 3, 4, 5].map((item: number, index: number) => (
              <div
                key={index}
                className="px-5 border-b border-strokePrimary w-full flex flex-col py-4 gap-4"
              >
                <div className="w-full flex justify-between">
                  <Skeleton width={20} height={24} />
                </div>
                <div className="w-full flex justify-between gap-[10px]">
                  <div className="w-full flex flex-col gap-[5px]">
                    <Skeleton width={100} height={15} />
                    <Skeleton width={window.innerWidth / 2 - 30} height={40} />
                  </div>
                  <div className="w-full flex flex-col gap-[5px]">
                    <Skeleton width={100} height={15} />
                    <Skeleton width={window.innerWidth / 2 - 30} height={40} />
                  </div>
                </div>
                <div className="w-full flex justify-between">
                  {isdisplayFeeColumn && (
                    <div className="w-full flex flex-col gap-[5px]">
                      <Skeleton width={100} height={15} />
                      <Skeleton
                        width={window.innerWidth / 2 - 30}
                        height={24}
                      />
                    </div>
                  )}
                  <div className="w-full flex flex-col gap-[5px]">
                    <Skeleton width={100} height={15} />
                    <Skeleton
                      width={
                        isdisplayFeeColumn
                          ? window.innerWidth / 2 - 30
                          : window.innerWidth - 50
                      }
                      height={24}
                    />
                  </div>
                </div>
              </div>
            ))}
            <div className="px-5 pb-5 w-full">
              <div className="w-full py-[32px] pb-6 flex justify-between items-center text-sm uppercase leading-[18px] text-txtSecondary font-medium border-b border-strokePrimary">
                <span>SubTotal</span>
                {isdisplayFeeColumn && <Skeleton width={70} height={25} />}
                <Skeleton width={70} height={25} />
              </div>
              <div className="py-6 flex uppercase w-full justify-between items-center text-txtPrimary text-lg font-semibold">
                <span>Total</span>
                <Skeleton width={70} height={30} />
              </div>
            </div>
          </>
        ) : (
          <div className="animate__animated animate__fadeIn mb-10">
            {newData?.map((data: any, index: number) => {
              const payment_date = formatScheduleDate(data);
              const tempDataArr = dataArr?.map((item: any) =>
                getTransactionScheduleDate(item)
              );
              if (index === 0) {
                storeBalance = userData?.data?.accountData?.balance;
              } else {
                storeBalance = remain;
              }
              remain = storeBalance - data?.amount;
              return (
                <div
                  className="w-full px-5 animate__animated animate__fadeIn animate__faster"
                  key={`${data?.date || data?.payment_date || ""}-${index}`}
                  onAnimationEnd={(e) =>
                    e.currentTarget.classList.remove(
                      "animate__animated",
                      "animate__fadeIn",
                      "animate__faster"
                    )
                  }
                >
                  <div className="border-b border-strokePrimary w-full flex flex-col py-4 gap-4">
                    <div className="w-full flex justify-between items-end">
                      <span className="text-base lowercase font-medium">
                        {index + 1}
                        {rowHelperText(index + 1)}
                      </span>
                      {isDateCustom &&
                        dataArr.length > 1 &&
                        data?.status === "Pending" && (
                          <span
                            className="cursor-pointer w-[18px] h-[18px]"
                            onClick={() => {
                              removeRow(index);
                            }}
                          >
                            <DeleteIcon />
                          </span>
                        )}
                    </div>
                    <div className="w-full flex gap-[10px]">
                      <div className={`relative flex flex-col w-full`}>
                        <div
                          className={`text-sm capitalize font-medium text-txtSecondary mb-[5px] leading-[15.62px]`}
                        >
                          Payment Date
                        </div>
                        <div
                          className={`relative`}
                          onClick={() => {
                            if (!makePayment) {
                              if (
                                (isDateCustom &&
                                  new Date() <= new Date(payment_date)) ||
                                !payment_date
                              ) {
                                setRowIndex(index + 1);
                                setIsMobileOpen(!isMobileOpen);
                              }
                            } else {
                              if (isDateCustom) {
                                setRowIndex(index + 1);
                                setIsMobileOpen(!isMobileOpen);
                              }
                            }
                          }}
                        >
                          <div
                            className={`${
                              data?.status !== "Pending" || !isDateCustom
                                ? "cursor-not-allowed pointer-events-none"
                                : "cursor-pointer"
                            } w-full`}
                          >
                            <InputField
                              type="dc-calendar"
                              disabled={
                                data?.status !== "Pending" || !isDateCustom
                              }
                              noLabel
                              _className="cursor-pointer hover:!border-strokeActive"
                              placeholder="MM/DD/YYYY"
                              value={payment_date}
                            />
                          </div>
                        </div>
                        {isDateCustom &&
                          isMobileOpen &&
                          index + 1 === rowIndex && (
                            <CustomCalender
                              value={
                                payment_date
                                  ? payment_date &&
                                    stringToDateObject(payment_date)
                                  : data.date && stringToDateObject(data.date)
                              }
                              minDate={new Date()}
                              maxDate={getStartLimit()}
                              disableTiles={tempDataArr.filter(
                                (item: any) => item !== payment_date
                              )}
                              openCalendar={isMobileOpen}
                              setOpenCalendar={setIsMobileOpen}
                              onChange={(date: any) => {
                                setIsMobileOpen(false);
                                handleChange(
                                  "date",
                                  index,
                                  dateToString(date),
                                  data
                                );
                              }}
                            />
                          )}
                      </div>
                      <div className="w-full">
                        <div
                          className={`text-sm capitalize font-medium text-txtSecondary mb-[5px] leading-[15.62px]`}
                        >
                          {amountType}
                        </div>
                        {amountType === "percent" ? (
                          <>
                            <InputSelect
                              maxHight="!max-h-[160px]"
                              // The list is clipped by the table's scroll area,
                              // so the bottom rows open their list upward.
                              isUpDropDown={
                                newData.length > 3 &&
                                index >= newData.length - 2
                              }
                              selected={findObjectByValue(
                                getPerOptions(),
                                data?.amount || 0
                              )}
                              value={
                                data?.amount !== undefined &&
                                data?.amount !== null &&
                                data?.amount !== ""
                                  ? `${data.amount}%`
                                  : ""
                              }
                              // error={
                              //   !data?.amount || data?.amount === 0
                              //     ? true
                              //     : false
                              // }
                              options={
                                data?.selectedPr?.length
                                  ? data?.selectedPr
                                  : options
                              }
                              setSelected={(val: any) => {
                                const percentage = Number(val?.value);
                                if (
                                  !Number.isFinite(percentage) ||
                                  percentage <= 0
                                ) {
                                  return;
                                }
                                setIsPaymentProcessing(true);
                                handleChange(
                                  "percent",
                                  index,
                                  percentage,
                                  data
                                );
                              }}
                              noLabel
                              disabled={data?.status !== "Pending"}
                            />
                          </>
                        ) : (
                          <CustomAmountInput
                            isError={
                              touchedArrayPhone[index] &&
                              (data.amount < min || data.amount > max)
                            }
                            isDollar={amountType === "amount"}
                            isPercentage={amountType === "percent"}
                            inputValue={
                              data.amount ? data?.amount?.toString() : ""
                            }
                            setinputValue={(val: any) => {}}
                            disabled={
                              isCustom && data?.status === "Pending"
                                ? false
                                : true
                            }
                            onBlur={(e: any) => {
                              setIsPaymentProcessing(true);
                              const val = e.target.value;
                              setTouchedArrayPhone((prev) => {
                                const updatedTouchedArray = [...prev];
                                updatedTouchedArray[index] = true;
                                return updatedTouchedArray;
                              });
                              let amt = val ? val?.replace(/,/g, "") : "0.00";
                              handleChange(
                                amountType === "percent" ? "percent" : "amount",
                                index,
                                Number(amt)
                              );
                              handleBlur(index, e.target.value);
                            }}
                            checkAmt={false}
                            className={`!pl-[23px]`}
                            showErr={false}
                          />
                        )}
                      </div>
                    </div>
                    <div className="w-full flex gap-[10px]">
                      {isdisplayFeeColumn && (
                        <div className="w-full flex flex-col">
                          <div
                            className={`text-sm capitalize font-medium text-txtSecondary mb-[5px] leading-[15.62px]`}
                          >
                            Fee
                          </div>
                          <div className="w-[15%] text-sm uppercase leading-[18px] text-gray1">
                            {formatCurrency(
                              getTransactionConvenienceFee(data)
                            ) || "$0.00"}
                          </div>
                        </div>
                      )}
                      <div className="w-full flex flex-col">
                        <div
                          className={`text-sm capitalize font-medium text-txtSecondary mb-[5px] leading-[15.62px]`}
                        >
                          Balance
                        </div>
                        <span className="text-lg leading-[24px] font-medium text-txtPrimary mr-[3px]">
                          {formatCurrency(
                            amountType === "percent" || makePayment
                              ? data?.balance
                              : remain
                          ) || "$0.00"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {isDateCustom && (
              <div className=" border-b border-strokePrimary">
                <div
                  className="py-4 flex gap-2 text-blue hover:!text-btnPrimaryHover cursor-pointer w-full px-5"
                  onClick={() => {
                    addNewRow(dataArr.length);
                  }}
                >
                  <AddCircleIconBlue />
                  Add new
                </div>
              </div>
            )}
            <div className="px-5">
              <div className="text-sm uppercase leading-[18px] text-txtSecondary font-medium  py-[32px] pb-6 w-full flex justify-between items-center border-b border-strokePrimary">
                <span>SubTotal</span>
                {isdisplayFeeColumn && (
                  <span className="text-lg text-txtPrimary">
                    {total_fee ? formatCurrency(total_fee) : "$0.00"}
                  </span>
                )}
                <span className="text-lg text-txtPrimary">
                  {totalAmount && totalAmount !== "0.00"
                    ? formatCurrency(totalAmount) || "0.00"
                    : "$0.00"}
                </span>
              </div>
              <div className="py-6 flex uppercase w-full justify-between items-center text-txtPrimary text-lg font-medium">
                <span>Total</span>
                <span className="text-2xl">
                  {grandTotal && grandTotal !== "0.00"
                    ? formatCurrency(grandTotal) || "0.00"
                    : "$0.00"}
                </span>
              </div>
            </div>
          </div>
        )}

        {isCustom && amtErr && (
          <p className="mb-2 px-5 text-xs text-red" role="alert">
            {amtErr}
          </p>
        )}
        <div className="mb-4 w-full px-5">
          <Button
            text="Next"
            className="w-full"
            isDisabled={
              isLoading ||
              isButtonDisabled ||
              isEndDateError ||
              (amtErr ? true : false)
            }
            onClick={() => {
              handleSave();
            }}
          />
        </div>
        {isCustom && isError && amountType === "amount" && (
          <div className="fixed bottom-[62px] left-0 right-0 mx-auto w-fit max-w-[var(--shell-vw)] px-5 z-10">
            <div className="w-full flex px-4 py-3 shadow-[0px_5px_15px_rgba(223,238,255,0.2)] rounded-t-[7px] bg-lightRed">
              <div className="text-red lg:text-base text-sm lg:leading-[21px]">
                Amount should be between {formatCurrency(min)} to{" "}
                {formatCurrency(max)}
              </div>
              <div className="flex items-center ml-[5px]">
                <span
                  onClick={() => {
                    setIsError(false);
                  }}
                  className="GreenIcon cursor-pointer w-[22px] h-[21px]"
                >
                  <CloseDanger />
                </span>
              </div>
            </div>
          </div>
        )}

        {isStartDateError && (
          <div className="fixed bottom-[62px] left-0 right-0 mx-auto w-fit max-w-[var(--shell-vw)] px-5 z-10">
            <div className="w-full flex px-4 py-3 shadow-[0px_5px_15px_rgba(223,238,255,0.2)] rounded-t-[7px] bg-lightRed">
              <div className="text-red lg:text-base text-sm lg:leading-[21px]">
                The first transaction’s date exceeds the allowed start date
                limit of {moment(getStartLimit()).format("MM/DD/YYYY")}.
              </div>
              <div className="flex items-center ml-[5px]">
                <span
                  onClick={() => {
                    setIsStartDateError(false);
                  }}
                  className="GreenIcon cursor-pointer w-[22px] h-[21px]"
                >
                  <CloseDanger />
                </span>
              </div>
            </div>
          </div>
        )}

        {isEndDateError && dateErrMsg && (
          <div className="fixed bottom-[62px] left-0 right-0 mx-auto w-fit max-w-[var(--shell-vw)] px-5 z-10">
            <div className="w-full flex px-4 py-3 shadow-[0px_5px_15px_rgba(223,238,255,0.2)] rounded-t-[7px] bg-lightRed">
              <div className="text-red lg:text-base text-sm lg:leading-[21px]">
                {dateErrMsg}.
              </div>
              <div className="flex items-center ml-[5px]">
                <span
                  onClick={() => {
                    setDateErrMsg(null);
                  }}
                  className="GreenIcon cursor-pointer w-[22px] h-[21px]"
                >
                  <CloseDanger />
                </span>
              </div>
            </div>
          </div>
        )}

        {/* The banners below use left/right/mx-auto rather than the browser's
            static position: a fixed box with auto insets lands wherever it
            happened to sit in flow, which pushed these off to one side. Insets
            and auto margins are proportional, so they centre identically at any
            --app-zoom. */}
        {showPercentHint && (
          <div className="fixed bottom-[62px] left-0 right-0 mx-auto w-fit max-w-[var(--shell-vw)] px-5 z-10">
            {/* Informational, not an error: the customer simply hasn't
                finished assigning percentages, so this reuses the warning-
                bar yellow instead of the error red. */}
            <div className="w-full flex px-4 py-3 shadow-[0px_5px_15px_rgba(223,238,255,0.2)] rounded-t-[7px] bg-lightYellow border border-btnYellowDisable">
              <div className="text-yellow font-medium lg:text-base text-sm lg:leading-[21px]">
                {percentHintMessage}
              </div>
              <div className="flex items-center ml-[5px]">
                <span
                  onClick={() => {
                    setIsPercentHintDismissed(true);
                  }}
                  className="cursor-pointer"
                >
                  <CloseIcon size={20} />
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CustomTable1;
